import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

const RESEND_COMPLETION_EMAIL_MUTATION = gql`
    mutation resendCompletionEmail($responseId: ID!) {
        resendCompletionEmail(responseId: $responseId) {
            completitionEmailSentAt
            completitionEmailSentStatus
        }
    }
`;

export function useResendCompletionEmailMutation() {
    return useMutation(RESEND_COMPLETION_EMAIL_MUTATION);
}
